import React from 'react'

function LeftNav({ navItems }) {
  return (
    <div className="LeftNav">
      <ul>
        {navItems.map((item) => {
          return (
            <a href={`#${item.navAnchor}`} key={item.navAnchor}>
              <li
                className="u-paddingVert3gu u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0"
                data-name={item.navAnchor}
              >
                <span className="u-paddingLeft2gu u-textSecondary">
                  {item.navLabel}
                </span>
              </li>
            </a>
          )
        })}
      </ul>
    </div>
  )
}

export default LeftNav
